import { useContext } from 'react';

import { SxProps } from '@cast/design-system';

import {
  useIsClusterDemoMode,
  useIsOpDemoMode,
} from '@cast/infrastructure-demo';
import { ToPortal } from 'core/portals';

import { EnableSecurityFeatureHeader } from './EnableSecurityFeatureHeader';
import { SecurityDemoHeader } from './SecurityDemoHeader';
import { SecurityDemoProviderContext } from '../SecurityDemoProvider';

type Props = {
  sx?: SxProps;
};

export const SecurityPageHeader = ({ sx }: Props) => {
  const { isSecurityDemoContentVisible } = useContext(
    SecurityDemoProviderContext
  );
  const isClusterDemoMode = useIsClusterDemoMode();
  const isOpDemoMode = useIsOpDemoMode();
  const showDemoHeader =
    isClusterDemoMode || isOpDemoMode || isSecurityDemoContentVisible;

  return (
    <ToPortal portal="PAGE_HEADER">
      {showDemoHeader ? (
        <SecurityDemoHeader sx={sx} />
      ) : (
        <EnableSecurityFeatureHeader sx={sx} />
      )}
    </ToPortal>
  );
};
